import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import { useMainLayoutContext } from '../MainLayout';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import LineChatAlertMenu from './LineChatAlertMenu';
export interface INavigationBarProps {
  children?: React.ReactNode,
  sx?: any,
  title?: string,
  tools?: React.ReactNode,
  historyBack?: string,
}

export default function NavigationBar(props: INavigationBarProps) {
  const navigate = useNavigate();
  const { navigationBarHeight, isSideBarOpen, sideBarWidth } = useMainLayoutContext()

  return (
    <Box position={'fixed'} height={navigationBarHeight} width={'100%'} top={0} left={0} sx={{
      zIndex: t => t.zIndex.appBar,
      pl: isSideBarOpen ? `${sideBarWidth}px` : 0,
      transition: theme => theme.transitions.create('padding', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      })
    }}>
      <Stack pl={6} pr={4} direction={'row'} justifyContent={'flex-start'} spacing={2} width={'100%'} height={'100%'} boxShadow={1} bgcolor={'common.white'} alignItems={'center'}>
        {props.historyBack && (
          <Button variant="outlined"  onClick={() => props.historyBack === 'function' ? navigate(-1) : navigate(props.historyBack!)}>
            <ArrowBack />
          </Button>
        )}
        <Typography fontWeight="bold" fontSize={24}>{props.title}</Typography>
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={2} sx={{}}>
          {props.tools}
          <LineChatAlertMenu />
        </Stack>
      </Stack>
    </Box>
  );
}
